export default class NumberHelper {
  static numericOnlyFromEvent(event: { key: string }): boolean {
    const patt = /^([0-9])$/;
    return patt.test(event.key);
  }
}
